import {
  OptimizationTimeSeriesMetric,
  OptimizationWorkload,
  OptimizationWorkloadContainerMetrics,
  WorkloadScalingPolicy,
} from '@cast/types';

import { ErrorStatusType, LowConfidenceStatusType } from './_constants';
import { PreparedEvent } from './types';

export type WithEvent = { event?: PreparedEvent };

export type ContainerMetricsWithEvent = OptimizationWorkloadContainerMetrics &
  WithEvent;

export type TimeSeriesMetricWithEvent = OptimizationTimeSeriesMetric &
  WithEvent;

export type HpaDisableReasons = {
  isDisabled: boolean;
  typeNotSupported: boolean;
  hasNativeHpa: boolean;
  managedByAnnotations: boolean;
  isCastware: boolean;
  isWoopAgentOutdatedForHpa: boolean;
  isCastAgentOutdatedForHpa: boolean;
};

export type StartupMetricsFormModel = {
  type: 'no-strategy' | 'two-phase' | 'ignore-startup';
  min: number;
  sec: number;
  isCustom: boolean;
};

export type ResourcesPair<T> = {
  cpu: T;
  memory: T;
};

export type ConstraintMode = 'constant' | 'percentage';

export type ResourcesConstraintsV2 = {
  min: number | null;
  max: number | null;
  mode: ConstraintMode;
};

export type WorkloadResourceLimitTypeFormModel =
  | 'AUTO'
  | 'MULTIPLIER'
  | 'NO_LIMIT'
  | 'KEEP_LIMITS'
  | 'SEMI_AUTOMATIC'
  | 'MAINTAIN_RATIO';

export type WorkloadResourceLimitFormModel = {
  type: WorkloadResourceLimitTypeFormModel;
  multiplier: number | null;
  semiAutoMultiplier: number | null;
};

export enum OptimizationThresholdType {
  DYNAMIC = 'DYNAMIC',
  PERCENTAGE = 'PERCENTAGE',
}

export type OptimizationThreshold = {
  type: OptimizationThresholdType;
  percentage: number | null;
};

export type ScalingPolicyWithWorkloads = WorkloadScalingPolicy & {
  workloads: OptimizationWorkload[];
  // todo:autopilot remove it when
  isOpsPilot?: boolean;
};
export type PolicyAutoscalerFormMode = 'IMMEDIATE' | 'DEFERRED';

export type Path<T, K extends keyof T = keyof T> = K extends string
  ? T[K] extends Record<string, any>
    ? `${K}.${Path<T[K]>}` | K
    : K
  : never;

export type OptimizationWorkloadContainerMetricsValues = keyof Omit<
  OptimizationWorkloadContainerMetrics,
  // todo(mike) remove limit omitting at UI-7000
  'timestamp' | 'limit'
>;

type AdditionalStatusTypes = ErrorStatusType | LowConfidenceStatusType;

export type FilterableStatuses =
  | 'STATUS_APPLIED'
  | 'STATUS_STOPPED'
  | AdditionalStatusTypes;

export type Savings = {
  estimatedMonthlySavings: number | undefined;
  estimatedMonthlySavingsPercentage: number | undefined;
  currentMonthlySavings: number | undefined;
  currentMonthlySavingsPercentage: number | undefined;
  currentMonthlyCost: number | undefined;
  currentRecommendedMonthlyCost: number | undefined;
};
